export default __webpack_public_path__ + "static/media/gallery_09.f89dc877.jpg";